<template>
  <GlobalAlertWindow
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
  >
    <el-descriptions direction="horizontal" :column="1">
      <el-descriptions-item label="会员昵称">{{ form.nikeName }}</el-descriptions-item>
      <el-descriptions-item label="真实姓名">{{ form.realname }}</el-descriptions-item>
      <el-descriptions-item label="性别">{{ form.sex==0?'男':form.sex==1?'女':'未知' }}</el-descriptions-item>
      <el-descriptions-item label="生日">{{ form.birthday }}</el-descriptions-item>
      <el-descriptions-item label="地区">{{ form.addr }}</el-descriptions-item>
      <el-descriptions-item label="联系方式">{{ form.phone }}</el-descriptions-item>
      <el-descriptions-item label="证件号码">{{ form.idcard }}</el-descriptions-item>
      <el-descriptions-item label="邮箱">{{ form.email }}</el-descriptions-item>
      <el-descriptions-item label="个人简介">{{ form.info }}</el-descriptions-item>
      <el-descriptions-item label="证件信息">
        <el-image style="margin-right: 10px; width: 160px; height: 90px; border-radius: 2px;" :src="form.idcardFullImg" :preview-src-list="[form.idcardFullImg, form.idcardImgFullBack]"></el-image>
        <el-image style="width: 160px; height: 90px; border-radius: 2px;" :src="form.idcardImgFullBack" :preview-src-list="[form.idcardFullImg, form.idcardImgFullBack]"></el-image>
      </el-descriptions-item>
      <el-descriptions-item label="过往经历">
        <div v-for="item in form.applyPlatList">
          {{ `${item.name}  ID：${item.nickname}   粉丝数：${item.fans}` }}
        </div>
      </el-descriptions-item>
    </el-descriptions>
    <div slot="footer"></div>
  </GlobalAlertWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalAlertWindow from '@/components/common/GlobalAlertWindow'
export default {
  name: 'OperaCouponWindow',
  extends: BaseOpera,
  components: { GlobalAlertWindow },
  data () {
    
    return {
      getDate: [],
      // 表单数据
      form: {
        id: null,
        nikeName: '',
        realname: '',
        sex: '',
        birthday: '',
        addr: '',
        phone: '',
        idcard: '',
        email: '',
        info: '',
        idcardImg: '',
        idcardImgBack: '',
        applyPlatList: '',
        idcardFullImg: '',
        idcardImgFullBack: '',
      },
      
    }
  },
  created () {
    this.config({
      api: '/business/coupon',
      'field.id': 'id'
    })
  },
  methods: {
    open (title, target) {
 
      this.title = title
      this.visible = true
      this.cities = []
      this.areas
      if (target == null) {
        this.$nextTick(() => {
          this.$refs.form.resetFields()
          this.form[this.configData['field.id']] = null
        })
        return
      }
      // 编辑
      this.$nextTick(() => {
        for (const key in this.form) {
          this.form[key] = target[key]
        }
        this.form.idcardFullImg = target.imgFullUrl + target.idcardImg
        this.form.idcardImgFullBack = target.imgFullUrl + target.idcardImgBack
        console.log(this.form);
      })
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
